import { TEST_API, ANSWER_API, ANALYSIS_API } from '@constants/api';
import _axios from '@plugins/_axios2';

/**
 * 获取题目
 * @param {Number} scheduleId 课程id
 */
export function getQuestions(scheduleId) {
    return _axios.get(TEST_API, {
        params: {
            scheduleId
        }
    });
}

/**
 * 交卷
 * @param {Number} scheduleId 课程id
 * @param {String} answers 学生每题选项集合
 * @param {Number} duration 答题时长
 */
export function answerQuestion({ scheduleId, answers, duration }) {
    return _axios.post(ANSWER_API, {
        scheduleId,
        answers,
        duration
    });
}

/**
 * 获取题目解析
 * @param {Number} scheduleId 课程id
 */
export function getAnalysis(scheduleId) {
    return _axios.post(ANALYSIS_API, {
        scheduleId
    });
}
